"use client";

import { useScroll, useSpring, useTransform } from "motion/react";
import * as m from "motion/react-m";
import * as React from "react";

export const DistanceTitle = () => {
  const sectionRef = React.useRef<HTMLDivElement>(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["center end", "start 0.2"],
  });

  const spacerValue = useTransform(scrollYProgress, [0, 1], ["26%%", "42%"]);
  const spacerWidth = useSpring(spacerValue, {
    visualDuration: 1.4,
    bounce: 0.2,
  });

  return (
    <div ref={sectionRef}>
      <h2 className="text-report-h2-mobile md:text-report-h2-tablet xl:text-report-h2 flex">
        <span className="block shrink-0">The AI deployment gap</span>
        <m.span style={{ width: spacerWidth }} />
        <span className="block shrink-0">&nbsp;is widening</span>
      </h2>
    </div>
  );
};
